var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"settings-wrapper"},[_c('page-header',{attrs:{"title":"Settings","breadcrumbText":"Dashboard >> Settings >> Roles & priviledges"}}),_c('div',{staticClass:"search-input-wrapper"},[_c('input',{staticClass:"search-input",attrs:{"type":"text","placeholder":"Search..."}}),_c('search-icon')],1),_c('settings-cards')],1)
}
var staticRenderFns = []

export { render, staticRenderFns }